import { createRoot } from 'react-dom/client';

import { CalculatorApp } from './components/CalculatorApp';

const selectBlocks = () =>
  Array.from(
    document.querySelectorAll<HTMLElement>('[data-ee-calculator="true"][data-hydrated="false"]'),
  );

const hydrateBlock = (root: HTMLElement) => {
  const eyebrow = root.dataset.eyebrow || 'Employee experience calculator';
  const heading = root.dataset.heading || 'What is standing still <em>really</em> costing you?';
  const description =
    root.dataset.description ||
    'Enter your numbers. See the financial cost of not acting on employee experience.';
  const heroBody = root.dataset.heroBody || '';
  const formSubheading = root.dataset.formSubheading || '';
  const guideUrl = root.dataset.guideUrl || '#';
  const guideImageUrl = root.dataset.guideImageUrl || '';
  const guideImageAlt = root.dataset.guideImageAlt || '';
  const guideBackImageUrl = root.dataset.guideBackImageUrl || '';
  const guideCardHeading = root.dataset.guideCardHeading || '';
  const resultLabel = root.dataset.resultLabel || 'Your annual cost of doing nothing:';
  const breakdownCtaHeading = root.dataset.breakdownCtaHeading || '';
  const breakdownCtaBody = root.dataset.breakdownCtaBody || '';
  const guideCtaText = root.dataset.guideCtaText || '';
  const popupHeading = root.dataset.popupHeading || '';
  const popupBody = root.dataset.popupBody || '';
  const country = root.dataset.country || '';

  root.innerHTML = '';

  const mount = createRoot(root);
  mount.render(
    <CalculatorApp
      eyebrow={eyebrow}
      heading={heading}
      description={description}
      heroBody={heroBody}
      formSubheading={formSubheading}
      guideUrl={guideUrl}
      guideImageUrl={guideImageUrl}
      guideImageAlt={guideImageAlt}
      guideBackImageUrl={guideBackImageUrl}
      guideCardHeading={guideCardHeading}
      resultLabel={resultLabel}
      breakdownCtaHeading={breakdownCtaHeading}
      breakdownCtaBody={breakdownCtaBody}
      guideCtaText={guideCtaText}
      popupHeading={popupHeading}
      popupBody={popupBody}
      country={country}
    />,
  );

  root.dataset.hydrated = 'true';
};

const start = () => {
  const hydrate = () => {
    selectBlocks().forEach(hydrateBlock);
  };

  const observer = new MutationObserver(hydrate);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  hydrate();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start, { once: true });
} else {
  start();
}
